module.exports = __webpack_public_path__ + "img/48-mensagens-nova.4afef896.png";